import { useState } from 'react'
import { X} from "lucide-react";
import showIcon from '../../../assets/showIcon.png'
import hideIcon from '../../../assets/hideIcon.png'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import {message} from '../../messages/Message'
import { updatePassword } from '../../services/operations/profileAPI';


const schema = yup.object().shape({
  newPassword: yup.string()
    .required(message.newPasswordRequiredMessage)
    .min(8, message.passwordMinMessage)
    .matches(
      /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^\w])[A-Za-z\d\W_]{8,}$/,
      message.passwordMatchMessage
    ),
  confirmPassword: yup.string()
    .oneOf([yup.ref('newPassword'), null], message.matchMessage)
    .required(message.confirmPasswordRequiredMessage),
});

const ChangePassword = ({ isOpen, onClose }) => {

  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch()

  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { register, handleSubmit, watch, formState: { errors }, trigger } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange"
  });

  const newPassword = watch('newPassword');
  const confirmPassword = watch('confirmPassword');

  const handleNewPasswordChange = (e) => {
    trigger('confirmPassword');
  };

  const submitPasswordForm = async (data) => {

     const encodedNewPassword = btoa( data.newPassword);
      const encodedConfirmPassword = btoa(data.confirmPassword);
    const payload = {
      new_password: encodedNewPassword,
      new_password_confirmation: encodedConfirmPassword
    }
    dispatch(updatePassword(token, payload, onClose))
  }

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword((pre) => !pre)
  }

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((pre) => !pre)
  }

  return (
    <div className="profile-account-overlay">
      <div className="profile-account-content" style={{ width: "440px", textAlign: "start" }}>
        <div className='profile-account-heading'>
          <p style={{ fontWeight: "600", fontSize: "20px" }}>Update Password</p>
          <X className="close-icon" onClick={onClose} />
        </div>
        <form onSubmit={handleSubmit(submitPasswordForm)} className="change-password-form">
          <div className="chnage-password-form-group">
            <label htmlFor="newPassword" className="change-password-form-label">
              New Password
            </label>
            <div className="password-input-wrapper">
              <input
                type={showNewPassword ? 'text' : 'password'}
                id="newPassword"
                maxLength={20}
                className={`change-password-form-input ${errors.newPassword ? 'input-error' : ''}`}
                {...register('newPassword', { onChange: handleNewPasswordChange })}
              />
              <span className="password-toggle-icon" onClick={toggleNewPasswordVisibility}>
                {showNewPassword ? <img src={hideIcon} alt='hide' /> : <img src={showIcon} alt='show' />}
              </span>
            </div>
            {errors.newPassword && <p className="error-message" style={{margin:"3px 0px 0px 0px"}}>{errors.newPassword.message}</p>}
          </div>
          <div className="chnage-password-form-group">
            <label htmlFor="confirmPassword" className="change-password-form-label">
              Confirm Password
            </label>
            <div className="password-input-wrapper">
              <input
                type={showConfirmPassword ? 'text' : 'password'}
                id="confirmPassword"
                className={`change-password-form-input ${errors.confirmPassword ? 'input-error' : ''}`}
                {...register('confirmPassword')}
              />
              <span className="password-toggle-icon" onClick={toggleConfirmPasswordVisibility}>
                {showConfirmPassword ? <img src={hideIcon} alt='hide' /> : <img src={showIcon} alt='show' />}
              </span>
            </div>
            {errors.confirmPassword ? (
              <p className="error-message" style={{margin:"3px 0px 0px 0px"}}>{errors.confirmPassword.message}</p>
            ) : (
              newPassword && confirmPassword && newPassword === confirmPassword && (
                <p className="success-message" style={{ color: 'green', fontSize: "small",margin:"3px 0px 0px 0px" }}>Password matched</p>
              )
            )}
          </div>
          <button type="submit" className="change-password-submit-button">
            Update Password
          </button>
        </form>


      </div>
    </div>
  )
}

export default ChangePassword;